exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".latModalWrapper {\n  position: fixed;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  z-index: 100000;\n  background: rgba(0,0,0,0.5);\n  overflow: hidden auto;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-start\n}\n.latModal {\n  background: white;\n  top: 100px;\n  max-width: 80%;\n  min-width: 280px;\n  padding: 20px 20px;\n  position: relative;\n  display: block;\n  z-index: 1050;\n}\n.closeButtonStyles {\n  float: right;\n  position: absolute;\n  right: 0;\n  top: 0\n}", ""]);

// exports
